var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationIcon06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-107.2%",
    y: "-69.7%",
    width: "314.4%",
    height: "239.3%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-89.3%",
    y: "-69.7%",
    width: "278.6%",
    height: "239.3%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-79%",
    y: "-69.7%",
    width: "257.9%",
    height: "239.3%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-153%",
    y: "-111.4%",
    width: "406%",
    height: "322.7%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-89.3%",
    y: "-69.7%",
    width: "278.6%",
    height: "239.3%",
    filterUnits: "objectBoundingBox",
    id: "e"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-79%",
    y: "-69.7%",
    width: "257.9%",
    height: "239.3%",
    filterUnits: "objectBoundingBox",
    id: "f"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-153%",
    y: "-111.4%",
    width: "406%",
    height: "322.7%",
    filterUnits: "objectBoundingBox",
    id: "g"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    filter: "url(#a)",
    d: "m15.198 28 5.597-17.225H9.601L15.198 28z",
    transform: "translate(9 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    filter: "url(#b)",
    d: "M15.198 28 9.601 10.775H1.758z",
    transform: "translate(9 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.758 10.775.057 16.009c-.155.478.015 1 .42 1.296L15.199 28 1.758 10.775Z",
    fill: "#FCA326",
    filter: "url(#c)",
    transform: "translate(9 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.758 10.775H9.6L6.231.4c-.174-.534-.93-.533-1.103 0l-3.37 10.375Z",
    fill: "#E24329",
    filter: "url(#d)",
    transform: "translate(9 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    filter: "url(#e)",
    d: "m15.198 28 5.597-17.225h7.844L15.198 28z",
    transform: "translate(9 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.639 10.775 1.7 5.234c.156.478-.014 1-.42 1.296L15.199 28l13.44-17.225Z",
    fill: "#FCA326",
    filter: "url(#f)",
    transform: "translate(9 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.639 10.775h-7.844L24.165.4c.174-.534.93-.533 1.103 0l3.37 10.375Z",
    fill: "#E24329",
    filter: "url(#g)",
    transform: "translate(9 8)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "m24.198 36 5.597-17.225H18.601L24.198 36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "m24.198 36-5.597-17.225h-7.843z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.758 18.775-1.701 5.234c-.155.478.015 1 .42 1.296L24.199 36l-13.44-17.225Z",
    fill: "#FCA326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.758 18.775H18.6L15.231 8.4c-.174-.534-.93-.533-1.103 0l-3.37 10.375Z",
    fill: "#E24329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "m24.198 36 5.597-17.225h7.844L24.198 36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.639 18.775 1.7 5.234c.156.478-.014 1-.42 1.296L24.199 36l13.44-17.225Z",
    fill: "#FCA326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.639 18.775h-7.844L33.165 8.4c.174-.534.93-.533 1.103 0l3.37 10.375Z",
    fill: "#E24329"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIcon06);
export default __webpack_public_path__ + "static/media/integration-icon-06.e54ac8a95b6b4c4ad869eb4fbf461874.svg";
export { ForwardRef as ReactComponent };